import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SwatchService } from "../../../services/swatch.service";
import { DesignphotoService } from "../../../services/index";
import { type } from "jquery";

declare var google;

@Component({
  selector: "research-Dc-List",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "researchDcList.html",
})
export class researchDcList implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList = [];
  typeList = ["R&D TO WAREHOUSE", "R&D TO TEXTILE","ALL"];
  statusList = ["Inwarded", "Pending"];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  filter = {
    //party_code:'',
    ref_no: "",
    design_no: "",
    ref_from_date: "",
    ref_to_date: "",
    type: "ALL",
    status : "Pending"
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "ref_no,dc_date",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  data: any;
  totalQty: any;
  constructor(
    public store: Store<fromRootStore.State>,
    private swatchservice: SwatchService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private designService: DesignphotoService,
  ) {
  }

  ngOnInit(): void {
    console.log(this.menu.param);

    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      swatchList: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref No",
        prop: "ref_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Date",
        prop: "dcdate",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "From",
        prop: "from_type",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "To",
        prop: "to_type",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Total Shirts/Mtrs",
        prop: "total",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Stock Status",
        prop: "stock_status",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      //  {name: 'No of Designs',prop: 'no_of_design',cellClass: 'text-center', minWidth: 80,maxWidth: 80,width: 80 },
      {
        name: "Action",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 180,
        width: 160,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#ref_no").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    //  this.filter.party_code= "";
    this.filter.ref_no = "";
    this.filter.design_no = "";
    this.filter.ref_from_date = "";
    this.filter.ref_to_date = "";
    this.filter.type = "ALL";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }

  addEditReaserch(mode: string, row: any, type: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD R&D TO WAREHOUSE / TEXTILE DC",
          title: "ADD R&D TO WAREHOUSE / TEXTILE DC",
          tabParent: "PURCHASE",
          mode: mode,
          type : type,
          data: row,
          name: "ADD R&D TO WAREHOUSE / TEXTILE DC",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT R&D TO WAREHOUSE / TEXTILE DC",
          title: "EDIT R&D TO WAREHOUSE / TEXTILE DC",
          tabParent: "PURCHASE",
          mode: mode,
          type : type,
          data: row,
          name: "EDIT R&D TO WAREHOUSE / TEXTILE DC",
        },
      };
    } else if (mode == "View"){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW R&D TO WAREHOUSE / TEXTILE DC",
          title: "VIEW R&D TO WAREHOUSE / TEXTILE DC",
          tabParent: "PURCHASE",
          mode: mode,
          type : type,
          data: row,
          name: "VIEW R&D TO WAREHOUSE / TEXTILE DC",
        },
      };
    } else if (mode == "Inward" && this.menu.param == 'TEXTILE'){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "INWARD R&D STOCK",
          title: "INWARD R&D STOCK",
          tabParent: "PURCHASE",
          mode: mode,
          type : type,
          data: row,
          name: "INWARD R&D STOCK",
        },
      };
    }else if (mode == "Inward" && this.menu.param == 'WAREHOUSE'){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "INWARD R&D STOCK",
          title: "INWARD R&D STOCK",
          tabParent: "PURCHASE",
          mode: mode,
          type : type,
          data: row,
          name: "INWARD R&D STOCK",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getOrderList(): void {
    if (this.filter.ref_from_date == "") {
      this.filter.ref_from_date == "";
    } else {
      this.filter.ref_from_date = this.datePipe.transform(
        this.filter.ref_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.ref_to_date == "") {
      this.filter.ref_to_date == "";
    } else {
      this.filter.ref_to_date = this.datePipe.transform(
        this.filter.ref_to_date,
        "yyyy-MM-dd"
      );
    }

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      ref_no: this.filter.ref_no,
      design_no: this.filter.design_no,
      ref_from_date: this.filter.ref_from_date,
      ref_to_date: this.filter.ref_to_date,
      type: this.filter.type,
      status: this.filter.status,
      param : this.menu.param
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask =  this.designService
      .getResearchDcList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.totalQty = res.totalQty;
      });
  }

  deleteSwatch(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Swatch Details?",
      text:
        "You will not be able to recover this Swatch" +
        " " +
        row["ref_no"] +
        "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.swatchservice
          .deleteSwatch(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

 
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/researchToWarehouseTextileDc/researchDcList.ts